import React, { useEffect } from 'react';
import './comp_box_div.css';

const Comp_Box_Div = (props) => {
  useEffect(() => {
    if(props.machineCounts.length>0){

      const total = parseFloat(props.machineCounts[0]["count_machines"]);
      const live = props.qulcActive;
      const percent = Math.round((live / total) * 100);
      const radius = 25;
      const circumference = 2 * Math.PI * radius;
  
      const circle = document.querySelector('.fg');
      const value = document.getElementById('percentValue');
  
      if (!circle || !value) return;
  
      circle.style.strokeDasharray = circumference;
      circle.style.strokeDashoffset = circumference;
  
      let currPercent = 0;
      let currValue = 0;
  
      const step = () => {
        if (currPercent < percent) {
          currPercent += 2;
          if (currPercent > percent) currPercent = percent;
          const offset = circumference - (currPercent / 100) * circumference;
          circle.style.strokeDashoffset = offset;
        }
  
        if (currValue < live) {
          currValue++;
          value.textContent = currValue;
        }
  
        if (currPercent < percent || currValue !== live) {
          requestAnimationFrame(step);
        }
      };
  
     
        step();
      

    }
  

    
  }, [props.machineCounts]);

  return (
   

          <div className="dashboard-container">
            <div className="header">
              <i className="fa fa-cogs fa-3x header-icon"></i>
              <h1>Oil Change All India</h1>
            </div>

            {/* Card 1 */}
            <div className="stat-card mx-2 text-start ">
              <div className="stat-row">
                <div className="stat-label">
                  Total No. of<br />Machines Installed
                </div>
                <div className="stat-value green ">
                  {props.machineCounts.length>0?props.machineCounts[0]["count_machines"]:''}
                  
                </div>
              </div>
            </div>

            {/* Card 2: Circular Progress */}
            <div className="stat-card mx-2">
              <div className="stat-row">
                <div className="stat-label text-start mb-2">
                  No. of<br />Machines Live
                </div>
                <div className="circle-progress">
                  {/* <svg width="60" height="60">
                    <circle className="bg" cx="30" cy="30" r="25" />
                    <circle className="fg" cx="30" cy="30" r="25" />
                  </svg> */}
                   <svg width="90" height="90">
                  <circle className="bg" cx="45" cy="45" r="40" />
                  <circle className="fg" cx="45" cy="45" r="40" />
                </svg>
                  <span className="value" id="percentValue">0</span>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="stat-card mx-2">
              <div className="stat-row">
                <div className="stat-label text-start">
                  Oil Changes<br />This Month
                </div>
                <div className="stat-value red pulse">
                  {/* <span className="plus-sign">+</span> */}
                  {props.currentMonthOilChange_V.length>0?props.currentMonthOilChange_V[0]["count_cc"]:''}
                </div>
              </div>
            </div>
          </div>

     
  );
};

export default Comp_Box_Div;
